module.exports = __webpack_public_path__ + "static/img/scbg_icon.png";